import { mapActions, mapMutations, mapState } from "vuex";

export default {
	computed: {
		...mapState({
			orders: (state) => state.order.index,
			waiting: (state) => state.order.waiting,
			ordersLoading: (state) => state.order.indexLoading,
			layout: (state) => {
				return state.order.layout
			},
			layoutLoading: (state) => state.order.layoutLoading,
			showModal: (state) => state.order.showModal,
			authenticate: (state) => state.user.authenticate,
			isUpgrade: (state) => state.flight.isUpgrade,
		}),
		...mapState("settings", {
			theme: (state) => state.theme,
		  }),
		layoutComp() {
			if (!this.isUpgrade) {
				return this.layout.filter((item) => item.category !== "upgradePlace");
			} else {
				return this.layout;
			}
		},
		servicesToShow(){
			return this.layout.filter((item) => item.category !== "upgradePlace"&&item.category !== "skyShop");
		}
	},
	methods: {
		...mapActions("order", {
			actionIndex: "index",
			actionLayout: "layout",
			setOrder: "setOrder",
			cancelOrder: "cancelOrder",
		}),
		...mapMutations("order", {
			setEntity: "SET_ENTITY",
		}),
		closeModal() {
			this.setEntity(["showModal", false]);
		},
		setOrderAction(item) {
			if (item.category === "upgradePlace") {
				this.setEntity(["showModal", false]);
				if (this.$route.name !== "UpgradeSeat") {
					this.$router.push({ name: "UpgradeSeat" });
				}
			} else if (
				item.category === "service" &&
				!this.orders.find((order) =>
					order.items.find((it) => it.id === item.id)
				)
			) {
				this.setOrder({
					id: +item.id,
				});
			}
		},
	},
}